import React from "react";
import "./Contact.css";
import { MapPin, Phone, Mail, Printer, PhoneCall } from "lucide-react";
import PageSEO from '../components/PageSEO';


const MAP_EMBED_URL = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2609.6960143253655!2d-122.84634779999999!3d49.1493958!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5485d988d0e2b3f3%3A0x56376319c9e48859!2sKeystone%20Insurance%20Brokers%20Ltd!5e0!3m2!1sen!2sca!4v1780559315605!5m2!1sen!2sca";


function Contact() {
  return (
    <>
    <PageSEO page="contact" />
    <div className="contact-page">

      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>We are here to help you with all your insurance needs.</p>
      </section>

      
      <section className="contact-info">
        <div className="info-card">
          <MapPin className="icon" />
          <h3>Address</h3>
          <p>103-8077 King George Blvd<br />Surrey, BC, Canada V3W 5B4</p>
        </div>
        <div className="info-card">
          <Phone className="icon" />
          <h3>Phone</h3>
          <p><a href="tel:6045958666">(604) 595-8666</a></p>
        </div>
        <div className="info-card">
          <Printer className="icon" />
          <h3>Fax</h3>
          <p>(604) 595-8668</p>
        </div>
        <div className="info-card">
          <Mail className="icon" />
          <h3>Email</h3>
          <p><a href="mailto:Keystoneins@shaw.ca">Keystoneins@shaw.ca</a></p>
        </div>
      </section>

      {/* --- Office Hours --- */}
      <section className="hours-section">
        <h2>Office Hours</h2>
        <div className="hours-grid">
          <div className="hours-row">
            <span>Monday – Friday</span>
            <span>9:00 AM – 8:00 PM</span>
          </div>
          <div className="hours-row">
            <span>Saturday – Sunday</span>
            <span>10:00 AM – 7:00 PM</span>
          </div>
        </div>
      </section>

      {/* --- Get a Quote CTA --- */}
      <section className="contact-cta-section">
        <div className="contact-cta-box">
          <PhoneCall size={40} className="contact-cta-icon" />
          <h2>Ready to Get a Quote?</h2>
          <p>
            Our licensed brokers are ready to help you find the right coverage
            at the best price. Give us a call or send us an email — we're happy
            to answer any questions you have, with no obligation.
          </p>
          <div className="contact-cta-actions">
            <a href="tel:6045958666" className="cta-btn-primary">
              <Phone size={16} /> Call (604) 595-8666
            </a>
            <a href="mailto:Keystoneins@shaw.ca" className="cta-btn-secondary">
              <Mail size={16} /> Keystoneins@shaw.ca
            </a>
          </div>
        </div>
      </section>

      {/* --- Map --- */}
      <section className="map-section">
        <h2>Find Us</h2>
        <div className="map-container">
          <iframe
            title="Keystone Insurance Brokers Location"
            src={MAP_EMBED_URL}
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: "12px", display: "block" }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>

    </div>
    </>
  );
}

export default Contact;